import { render, staticRenderFns } from "./SEFAlignment.vue?vue&type=template&id=bec88972&scoped=true&"
import script from "./SEFAlignment.vue?vue&type=script&lang=js&"
export * from "./SEFAlignment.vue?vue&type=script&lang=js&"
import style0 from "./SEFAlignment.vue?vue&type=style&index=0&id=bec88972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec88972",
  null
  
)

export default component.exports